import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export const ARRIVAL_DATE_FILTER_ID = 'screening-report-filter-arrival-date';
export const DEPARTURE_DATE_FILTER_ID = 'screening-report-filter-departure-date';

/** Date filter inputs for the screening report. Provided by ScreeningReportComponent, so each page gets its own. */
@Injectable()
export class ScreeningReportFilterStateService {

  readonly dates: Record<string, Date | null> = {
    [ARRIVAL_DATE_FILTER_ID]: null,
    [DEPARTURE_DATE_FILTER_ID]: null
  };

  /** Emits the id of the date filter whose Apply or Reset was clicked. */
  readonly changed = new Subject<string>();
}
